import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Swiper, SwiperSlide } from 'swiper/react'

function SliderMain() {
  const [data, setData] = useState([])

  const {
    i18n: { language },
  } = useTranslation()

  useEffect(() => {
    fetch('/data/Main/SliderMain/data.json')
      .then((res) => res.json())
      .then((data) => {
        setData(data)
      })
  }, [])

  return (
    <Container>
      <MoImg />
      <MoTextBox>
        <div className="en">Make all of us relief again</div>
        {language === 'ko' && (
          <div className="ko">우리 모두가 다시 안심할 수 있게</div>
        )}
      </MoTextBox>
      <StyledSwiper
        modules={[Pagination, Navigation, Autoplay]}
        direction="vertical"
        slidesPerView={1}
        loop={true}
        speed={1000}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          type: 'progressbar',
        }}
        className="mySwiper"
      >
        {data.map((data) => {
          return (
            <SwiperSlide key={data.id}>
              <Img src={data.img} />
            </SwiperSlide>
          )
        })}
      </StyledSwiper>

      <ContentBox>
        <TitleE>Make all of us relief again</TitleE>
        {language === 'ko' && <TitleK>우리 모두가 다시 안심할 수 있게</TitleK>}
      </ContentBox>
      {/* <ArrowButton
        onClick={() => {
          window.screen.width > 768
            ? window.scrollTo({ left: 0, top: 925, behavior: 'smooth' })
            : window.scrollTo({ left: 0, top: 650, behavior: 'smooth' })
        }}
      />
      <ArrowButton2
        onClick={() => {
          window.screen.width > 768
            ? window.scrollTo({ left: 0, top: 925, behavior: 'smooth' })
            : window.scrollTo({ left: 0, top: 650, behavior: 'smooth' })
        }}
      /> */}
    </Container>
  )
}

export default SliderMain

const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;

  .swiper-wrapper {
    width: 100%;
    max-width: 1440px;
    height: 1024px;
  }
  .swiper-slide {
    display: flex;
    justify-content: end;
    padding-right: 70px;
    align-items: center;
  }

  .swiper-pagination {
    color: transparent;

    .swiper-pagination-current,
    .swiper-pagination-total {
      color: ${({ theme }) => theme.color.WPrimary};
    }

    .swiper-pagination-current {
      position: absolute;
      top: -355px;
      right: 44px;
      width: 19px;
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;

      ::after {
        position: absolute;
        top: 50px;
        left: -17px;
        width: 50px;
        height: 0px;
        border: 0.5px solid #ffffff;
        transform: rotate(90deg);
        content: '';
      }
    }

    .swiper-pagination-total {
      position: absolute;
      top: -268px;
      right: 44px;
      width: 19px;
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
    }
  }

  .swiper-pagination-progressbar {
    position: absolute;
    left: 1388px;
    top: 154px;
    width: 2px;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.3);

    .swiper-pagination-progressbar-fill {
      width: 2px;
      background-color: ${({ theme }) => theme.color.WPrimary};
    }
  }
  @media all and (max-width: 1024px) {
    display: none;
  }
`

const ArrowButton = styled.div`
  position: absolute;
  right: 0px;
  left: 0;
  bottom: 0px;
  width: 140px;
  height: 150px;
  z-index: 2;
  background: url('/assets/images/main/main/Shadow.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  cursor: pointer;
  @media all and (max-width: 1024px) {
    background: url(/assets/icons/arrow_mo.png);
    top: 31rem;
    left: 17rem;
    background-repeat: no-repeat;
    background-position: center center;
    backdrop-filter: none;
    width: 7rem;
  }
`

const ArrowButton2 = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100px;
  height: 100px;
  z-index: 2;
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
  background: url(/assets/images/main/main/arrow2.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto;
  cursor: pointer;

  @media all and (max-width: 1024px) {
    display: none;
  }
`

const Container = styled.div`
  /* position: relative; */
  max-width: 1440px;
  width: 100%;
  height: 1024px;
  background: url('/assets/images/main/SliderMain_back.png');

  .SwiperBody {
    position: absolute;
    top: 0;
  }

  @media all and (max-width: 1024px) {
    margin-top: 4rem;
    background: url('/assets/images/main/mobile/mo.png');
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 40rem;
    position: relative;
  }
`

const ContentBox = styled.div`
  position: absolute;
  top: 0;
  width: 700px;
  height: auto;
  z-index: 10;
  margin-top: 309px;
  padding: 70px 60px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(50px);
  @media all and (max-width: 1024px) {
    display: none;
  }
`

const TitleE = styled.div`
  font-family: 'Montserrat';
  font-weight: 700;

  font-size: 80px;
  line-height: 98px;
  color: ${({ theme }) => theme.color.WPrimary};
`

const TitleK = styled.div`
  margin-top: 40px;
  font-weight: 700;

  font-size: 40px;
  line-height: 58px;
  color: ${({ theme }) => theme.color.WPrimary};
`

const Img = styled.img`
  width: auto;
  height: auto;
  max-height: 750px;
  aspect-ratio: 1.5/1;
  @media all and (max-width: 1024px) {
    width: 100%;
  }
`
const MoImg = styled.img`
  display: none;

  @media all and (max-width: 1024px) {
    display: block;
    position: absolute;
    top: 4rem;
    right: 0;
    height: 75%;
    width: 20rem;
    background: url(/assets/images/main/main_mo.png);
  }
`
const MoTextBox = styled.div`
  display: none;

  @media all and (max-width: 1024px) {
    display: block;
    position: absolute;
    top: 10rem;
    left: 0;
    height: auto;
    width: calc(100% - 60px);
    background: rgba(255, 255, 255, 0.4);
    -webkit-backdrop-filter: blur(50px);
    backdrop-filter: blur(50px);
    color: #fff;
    padding: 2rem;
    font-weight: 700;

    .en {
      font-size: 2rem;
      line-height: 2.5rem;
    }
    .ko {
      font-size: 1rem;
      margin-top: 2rem;
    }
  }
`
